module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    attrs: {
      "md8": ""
    }
  }, [_c('ItemCheckList', {
    attrs: {
      "item-id": _vm.$store.getters.currentUser.id,
      "item-type": _vm.itemType,
      "casesId": _vm.casesid
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-375d314a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CaseFormsCheckList.vue
// module id = 981
// module chunks = 1